// Generated list of Material Symbols (rounded, weight 400) used by the app.

import menu from '@material-symbols/svg-400/rounded/menu.svg?raw';
import search from '@material-symbols/svg-400/rounded/search.svg?raw';
import add from '@material-symbols/svg-400/rounded/add.svg?raw';
import close from '@material-symbols/svg-400/rounded/close.svg?raw';
import arrowBack from '@material-symbols/svg-400/rounded/arrow_back.svg?raw';
import checkBox from '@material-symbols/svg-400/rounded/check_box.svg?raw';
import checkBoxOutlineBlank from '@material-symbols/svg-400/rounded/check_box_outline_blank.svg?raw';
import tag from '@material-symbols/svg-400/rounded/tag.svg?raw';
import folder from '@material-symbols/svg-400/rounded/folder.svg?raw';
import folderOpen from '@material-symbols/svg-400/rounded/folder_open.svg?raw';
import keep from '@material-symbols/svg-400/rounded/keep.svg?raw';
import keepFill from '@material-symbols/svg-400/rounded/keep-fill.svg?raw';
import archive from '@material-symbols/svg-400/rounded/archive.svg?raw';
import unarchive from '@material-symbols/svg-400/rounded/unarchive.svg?raw';
import deleteIcon from '@material-symbols/svg-400/rounded/delete.svg?raw';
import share from '@material-symbols/svg-400/rounded/share.svg?raw';
import moreVert from '@material-symbols/svg-400/rounded/more_vert.svg?raw';
import formatBold from '@material-symbols/svg-400/rounded/format_bold.svg?raw';
import formatItalic from '@material-symbols/svg-400/rounded/format_italic.svg?raw';
import formatStrikethrough from '@material-symbols/svg-400/rounded/format_strikethrough.svg?raw';
import formatH1 from '@material-symbols/svg-400/rounded/format_h1.svg?raw';
import formatH2 from '@material-symbols/svg-400/rounded/format_h2.svg?raw';
import formatH3 from '@material-symbols/svg-400/rounded/format_h3.svg?raw';
import formatListBulleted from '@material-symbols/svg-400/rounded/format_list_bulleted.svg?raw';
import formatListNumbered from '@material-symbols/svg-400/rounded/format_list_numbered.svg?raw';
import checklist from '@material-symbols/svg-400/rounded/checklist.svg?raw';
import undo from '@material-symbols/svg-400/rounded/undo.svg?raw';
import redo from '@material-symbols/svg-400/rounded/redo.svg?raw';
import darkMode from '@material-symbols/svg-400/rounded/dark_mode.svg?raw';
import lightMode from '@material-symbols/svg-400/rounded/light_mode.svg?raw';
import brightnessAuto from '@material-symbols/svg-400/rounded/brightness_auto.svg?raw';
import logout from '@material-symbols/svg-400/rounded/logout.svg?raw';
import personAdd from '@material-symbols/svg-400/rounded/person_add.svg?raw';
import link from '@material-symbols/svg-400/rounded/link.svg?raw';
import linkOff from '@material-symbols/svg-400/rounded/link_off.svg?raw';
import cloudOff from '@material-symbols/svg-400/rounded/cloud_off.svg?raw';
import cloudDone from '@material-symbols/svg-400/rounded/cloud_done.svg?raw';
import sync from '@material-symbols/svg-400/rounded/sync.svg?raw';
import stickyNote2 from '@material-symbols/svg-400/rounded/sticky_note_2.svg?raw';
import chevronRight from '@material-symbols/svg-400/rounded/chevron_right.svg?raw';
import keyboardArrowDown from '@material-symbols/svg-400/rounded/keyboard_arrow_down.svg?raw';
import contentCopy from '@material-symbols/svg-400/rounded/content_copy.svg?raw';
import settings from '@material-symbols/svg-400/rounded/settings.svg?raw';
import inbox from '@material-symbols/svg-400/rounded/inbox.svg?raw';
import group from '@material-symbols/svg-400/rounded/group.svg?raw';
import editNote from '@material-symbols/svg-400/rounded/edit_note.svg?raw';
import check from '@material-symbols/svg-400/rounded/check.svg?raw';
import palette from '@material-symbols/svg-400/rounded/palette.svg?raw';
import lightbulb from '@material-symbols/svg-400/rounded/lightbulb.svg?raw';
import personRemove from '@material-symbols/svg-400/rounded/person_remove.svg?raw';
import visibility from '@material-symbols/svg-400/rounded/visibility.svg?raw';
import description from '@material-symbols/svg-400/rounded/description.svg?raw';

export const icons = {
  menu: menu,
  search: search,
  add: add,
  close: close,
  arrow_back: arrowBack,
  check_box: checkBox,
  check_box_outline_blank: checkBoxOutlineBlank,
  tag: tag,
  folder: folder,
  folder_open: folderOpen,
  keep: keep,
  keep_fill: keepFill,
  archive: archive,
  unarchive: unarchive,
  delete: deleteIcon,
  share: share,
  more_vert: moreVert,
  format_bold: formatBold,
  format_italic: formatItalic,
  format_strikethrough: formatStrikethrough,
  format_h1: formatH1,
  format_h2: formatH2,
  format_h3: formatH3,
  format_list_bulleted: formatListBulleted,
  format_list_numbered: formatListNumbered,
  checklist: checklist,
  undo: undo,
  redo: redo,
  dark_mode: darkMode,
  light_mode: lightMode,
  brightness_auto: brightnessAuto,
  logout: logout,
  person_add: personAdd,
  link: link,
  link_off: linkOff,
  cloud_off: cloudOff,
  cloud_done: cloudDone,
  sync: sync,
  sticky_note_2: stickyNote2,
  chevron_right: chevronRight,
  keyboard_arrow_down: keyboardArrowDown,
  content_copy: contentCopy,
  settings: settings,
  inbox: inbox,
  group: group,
  edit_note: editNote,
  check: check,
  palette: palette,
  lightbulb: lightbulb,
  person_remove: personRemove,
  visibility: visibility,
  description: description,
} as const;

export type IconName = keyof typeof icons;
